import React, { useEffect, useState } from 'react'
import { Box, TextField } from "@mui/material";
import StoreProductsTable from './StoreProductTable';
import getAccess from '../../../utils/getAccess';

const StoreProduct = () => {
  const [loading, setLoading] = useState(true);
  const [rows, setRows] = useState([]);
  const [rowCount, setRowCount] = useState(0);
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 25,
  });
  const [search, setSearch] = useState("");
  const fetchProduct = async () => {
    const token = localStorage.getItem("token");
    setLoading(true);

    try {
      const res = await fetch(
        `${process.env.REACT_APP_LIVE_URL}/store/getAllStoreProduct` +
        `?page=${paginationModel.page}` +
        `&pageSize=${paginationModel.pageSize}` +
        `&searchText=${encodeURIComponent(search)}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const json = await res.json();

      setRows(json.data || []);
      setRowCount(json.pagination?.totalCount || json.count || 0);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchProduct();
  }, [paginationModel.page, paginationModel.pageSize, search]);


  return (
    <Box>

      <Box m={2}>
        <TextField
          size="small"
          placeholder="Search & press Enter"
          sx={{ width: 300 }}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              const value = e.target.value;

              setSearch(value);
              setPaginationModel(p => ({
                ...p,
                page: 0
              }));
            }
          }}
        />

      </Box>

      <StoreProductsTable
        rows={rows}
        loading={loading}
        rowCount={rowCount}
        paginationModel={paginationModel}
        setPaginationModel={setPaginationModel}
        refresh={fetchProduct}
        setSearch={setSearch}
      />

    </Box>
  );
}

export default StoreProduct;
